import React, { useEffect } from "react";
import "./HomePage.css";
import { CalendarComponent } from "@syncfusion/ej2-react-calendars";
import { Navigate } from "react-router-dom";
import axios from "../axios";
import { useState } from "react";
import { SubjectIcon } from "../SubjectIcon";
import "intro.js/introjs.css";
import { Steps } from "intro.js-react";
import HomePageTourPopup from "./HomePageTourPopup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHandPointRight } from "@fortawesome/free-solid-svg-icons";
import HistoryDetaulsPopup from "./HistoryDetailsPopup";
import { Tooltip } from "@mui/material";
import UpcomingLecInsPopup from "./UpcomingLecInsPopup";
import UpcomingMainContent from "./UpcomingMainContent";
import NoticeBoardPopUp from "./NoticeBoardPopUp";
import { getCurrentFormattedDate } from "../utils/datetime_helper";
import { hasFeature } from "../utils/features";
import { getTimeTable } from "../DCM/services/time-table-service";
import { getDefaultWeekRange } from "../utils/helper";

export default function HomePage() {
  localStorage.setItem("ActiveHeader", "MyFeed");
  localStorage.setItem("footerActive", "Home");

  const [stepsEnabled, setStepsEnabled] = useState(false);
  const [events, setEvents] = useState([]);
  const [initialStep, setInitialStep] = useState(0);
  const [openPop, setopenPop] = useState(false);
  const [noticeBoxOpen, setNoticeBoxOpen] = useState(false);
  const [homeScreenWalkThroughPopup, setHomeScreenWalkThroughPopup] =
    useState(false);
  useEffect(() => {
    // Check if the popup has been shown before
    const hasShownPopup = localStorage.getItem("hasShownPopup");
    if (!hasShownPopup) {
      // Show the steps if it hasn't been shown before
      setHomeScreenWalkThroughPopup(true);
      // Set the flag in localStorage to indicate the popup has been shown
      localStorage.setItem("hasShownPopup", "true");
    }
  }, []);
  const { firstdayDefault, lastdayDefault } = getDefaultWeekRange();


  //prevent to go back
  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
  }, []);

  const [steps, setSteps] = useState([
    {
      element: ".FoterDetailContainer",
      intro: `
        <h3>Parent Features Bottom Pane</h3>
        <p>These are 4 Parents, each Parent has multiple features listed on the left most pane. Currently 'Home' parent is selected.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".home",
      intro: `
        <h3>Home</h3>
        <p>Home has 4 features (as shown in left most pane):
       </p>
       <ol>
          <li>My Feed</li>
          <li>Library</li>
          <li>Calendar</li>
        </ol>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".featuredLeftPane",
      intro: `
        <h3>Features Group Left Pane
        Home has 3 features as shown:</h3>
        <ol>
          <li>My Feed</li>
          <li>Library</li>
          <li>Calendar</li>
        </ol>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".myFeed",
      intro: `
        <h3>MyFeed</h3>
        <p>Currently 'My feed' feature is selected</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".myFeed2",
      intro: `
        <h3>MyFeed</h3>
        <p>Let's navigate through my feed feature</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },

    {
      element: ".calenderHomePage ",
      intro: `
        <h3>Live Calender</h3>
        <p>It will keep ypu updated with days and dates</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".noticeBoardTitle  ",
      intro: `
        <h3>School Notice Board</h3>
        <p>You wil find all the school notices here. Click on notice item to get its details.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".thoughts  ",
      intro: `
        <h3>Motivational Thoughts</h3>
        <p>Thoughts from great leaders to keep you positive and motivated in life.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".todaysHistory",
      intro: `
        <h3>Today's Importance In History</h3>
        <p>Get to know today's date importance in history.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".upcomingClasses",
      intro: `
        <h3>Upcoming Classes</h3>
        <p>Know your upcoming classes here.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".prifilePic",
      intro: `
        <h3>Your profile, B4S App layout</h3>
        <p>Access your profile Information.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
    {
      element: ".done",
      intro: `
        <h3>Awesome, you are done. 😊</h3>
        <p>Click anywhere on the screen or click on the cross icon.</p>
      `,
      position: "top",
      tooltipClass: "myTooltipClass",
      highlightClass: "myHighlightClass",
    },
  ]);
  const onExit = () => {
    setStepsEnabled(false);
  };
  const isLoggedIn = true;
  let Student_Id = JSON.parse(localStorage.getItem("breathForStudent"));
  const [data, setData] = useState([]);
  const [news, setNews] = useState([]);
  const [thoughts, setThoughts] = useState([]);
  const [lectures, setLectures] = useState([]);
  const [specialLectures, setSpecialLectures] = useState([]);
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupText, setPopupText] = useState("");
  const [popupTitleText, setPopupTitleText] = useState("");
  const [noticeData, setNoticeData] = useState(null);
  const [alreadyStartDate, setAlreadyStartDate] = useState(null);
  const [alreadyEndDate, setAlreadyEndDate] = useState(null);
  useEffect(() => {
    let res1 = {
      student_id: Student_Id?.id,
    };
    try {
      const helper = async () => {
        let studentRes = await axios.post(
          "/noticeBoard/notice/getByStudent",
          res1
        );
        let schoolRes = await axios.get(
          `/noticeBoard/notice/getByStandard?standard_id=${Student_Id?.standard?.id}&timetableSession_id=${Student_Id?.timetable_session?.id}`
        );
        if (studentRes?.data?.status || schoolRes?.data?.status) {
          setData([
            ...(studentRes?.data?.data || []),
            ...(schoolRes?.data?.data || []),
          ]);
        }
      };
      helper();
    } catch (error) {
      console.log(error.data.message);
    }
  }, []);
  useEffect(() => {
    const getCurrentDate = () => {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    const helper1 = async () => {
      const date = getCurrentDate();
      const standardId = Student_Id?.standard?.id;

      try {
        const response3 = await axios.get(`/messageBoard/getThoughtOfTheDay`);
        if (response3) setThoughts(response3?.data?.data);
        const response2 = await axios.get(
          `/messageBoard/dailyEventStory/get?standardId=${standardId}&date=${date}`
        );
        if (response2) setNews(response2?.data?.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    helper1();
  }, []);



  useEffect(() => {
    const loadDefault = async () => {
      setAlreadyStartDate(new Date(firstdayDefault).getDate());
      setAlreadyEndDate(new Date(lastdayDefault).getDate());

      try {
        const eventsData = await getTimeTable(firstdayDefault, lastdayDefault);
        console.log("eventsData from homepage", eventsData);

        const events = eventsData[0];
        setEvents(events);
      } catch (e) {
        console.error("Failed to fetch default events data:", e);
      } finally {
        // setLoading(false);
      }
    };

    loadDefault();
  }, []);

  useEffect(() => {
    try {
      const helper3 = async () => {
        let response1 = await axios.get(
          `/timetable/getUpcomingClasses/academicYearId/${Student_Id.academic_year.id}/schoolId/${Student_Id.school.id}/standardId/${Student_Id.standard.id}/sectionId/${Student_Id.section.id}/timetableSessionId/${Student_Id.timetable_session.id}`
        );
        setLectures(response1?.data?.data[0]?.schedules[0]?.lectures);
        setSpecialLectures(
          response1?.data?.data[0]?.schedules[0]?.special_lectures
        );
      };
      helper3();
    } catch (error) {
      console.log("error", error);
    }
  }, []);
  if (!isLoggedIn) {
    return <Navigate to="/" />;
  }
  function getGreeting() {
    var currentTime = new Date();
    var currentHour = currentTime.getHours();
    var greeting;

    if (currentHour >= 6 && currentHour < 12) {
      greeting = "Good morning!";
    } else if (currentHour >= 12 && currentHour < 16) {
      greeting = "Good afternoon!";
    } else {
      greeting = "Good evening!";
    }
    return greeting;
  }

  function formatTime(inputTime) {
    inputTime = inputTime.toString();
    if (inputTime.length < 4) {
      return "Invalid time";
    }

    const hours = inputTime?.slice(0, 2);
    const minutes = inputTime?.slice(2);

    if (isNaN(hours) || isNaN(minutes)) {
      return "Invalid time";
    }

    let formattedHours = parseInt(hours, 10);
    const amPm = formattedHours >= 12 ? "PM" : "AM";

    if (formattedHours === 0) {
      formattedHours = 12;
    } else if (formattedHours > 12) {
      formattedHours -= 12;
    }

    const formattedHoursString = formattedHours.toString().padStart(2, "0");
    const formattedTime = `${formattedHoursString}:${minutes} ${amPm}`;

    return formattedTime;
  }
  function checkClassStatus(startTime, endTime) {
    const now = new Date();
    const currentHours = now.getHours().toString().padStart(2, "0");
    const currentMinutes = now.getMinutes().toString().padStart(2, "0");
    const currentTime = parseInt(`${currentHours}${currentMinutes}`, 10);
    const start = parseInt(startTime, 10);
    const end = parseInt(endTime, 10);
    if (currentTime >= start && currentTime <= end) {
      return "Join now";
    } else {
      return "Join now";
    }
  }
  function checkClassStatus1(startTime, endTime, bbbId) {
    const now = new Date();
    const currentHours = now.getHours().toString().padStart(2, "0");
    const currentMinutes = now.getMinutes().toString().padStart(2, "0");
    const currentTime = parseInt(`${currentHours}${currentMinutes}`, 10);
    const start = parseInt(startTime, 10);
    const end = parseInt(endTime, 10);
    if (currentTime >= start && currentTime <= end && bbbId !== undefined) {
      return "Join now";
    } else {
      return "Upcoming class";
    }
  }
  const joinClass = async (id) => {
    try {
      if (id !== undefined) {
        let res1 = await axios.get(
          `/videoConference/classes/join/${id}?viewer_name=${Student_Id.name}`
        );
        var win = window.open(res1.data.data, "_blank");
        win.focus();
      }
    } catch (error) {
      console.log(error);
    }
  };

  //I added this function for reduce the history paragraph length
  const reduceParagraphLength = (text, maxLength) => {
    if (!text || typeof text !== "string") {
      return "";
    }
    if (text.length <= maxLength) {
      return text;
    }
    return text.slice(0, maxLength) + "...";
  };
  const youtubeLink = news?.Link?.match(/src="([^"]+)"/)?.[1];
  function formatDateNew(inputDate) {
    const date = new Date(inputDate);
    const monthAbbreviations = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = String(date.getDate()).padStart(2, "0");
    const month = monthAbbreviations[date.getMonth()];
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }
  const handleOpenPopup = (text, title) => {
    setPopupText(text);
    setPopupTitleText(title);
    setPopupVisible(true);
  };

  // Close Popup
  const handleClosePopup = () => {
    setPopupVisible(false);
    setPopupText("");
  };

  // const today = new Date().toISOString().split("T")[0];

  return (
    <div>
      <Steps
        enabled={stepsEnabled}
        steps={steps}
        initialStep={initialStep}
        onExit={onExit}
      />
      <div className="row mt-3">
        <div className="col-md-9">
          <div className="helloImgContainer p-2">
            <div
              className="textHelloImg1 d-flex align-items-center justify-content-between flex-wrap"
              style={{ position: "relative" }}
            >
              <div className="pl-4 ml-3" style={{ width: "72%" }}>
                <span className="hiravi">
                  👋 Hi {Student_Id.name},
                  <span className="goodMornig"> {getGreeting()}</span>
                </span>
                <div className="HelloImgBelowText thoughts">
                  {thoughts[0]?.quote || ""}
                </div>
                <div className="HelloImgAuthor">
                  - {thoughts[0]?.author || ""}
                </div>
              </div>
              <div className="textpersonImgContainer">
                {Student_Id.gender === "M" && (
                  <img
                    className="textpersonImg"
                    src="/HomePageImg/male.svg"
                    alt=""
                  />
                )}
                {Student_Id.gender === "F" && (
                  <img
                    className="textpersonImgGrl"
                    src="/HomePageImg/female.svg"
                    alt=""
                  />
                )}
              </div>
            </div>
          </div>
          <div className="mt-3 p-2 bulbImgContainer">
            <div className="tdh">{news?.b4s_category}</div>
            {/* <span >
              
            </span> */}

            <div className="d-flex p-0.5 align-items-center">
              <div className=" thmbnail d-flex align-items-center pt-1">
                {/* If history and history img not available then handle the error */}

                {news?.b4s_category === "Inspirational Story of the Day" ? (
                  <img
                    className="historyimg"
                    src={
                      news.Image
                        ? news?.Image
                        : "/images/Default_Inspirational_Stories_Icon.png"
                    }
                    alt=""
                  />
                ) : news?.b4s_category === "Moral Story of the Day" ? (
                  <img
                    className="historyimg"
                    src={
                      news.Image
                        ? news?.Image
                        : "/images/Default_Moral_Stories_Icon.png"
                    }
                    alt=""
                  />
                ) : (
                  <img
                    src="/images/Default_Other_Stories_Icon.png"
                    className="historyimg"
                    alt=""
                  />
                )}
              </div>

              <div
                className={`todaysHistory`}
                onClick={news?.title ? () => setopenPop(true) : null}
                style={{ cursor: news?.title ? "pointer" : "default" }}
              >
                <div className={`todayHistoryText textDemo`}>
                  {news?.title
                    ? news?.title
                    : getCurrentFormattedDate(new Date())}
                  {/* {' ' + getCurrentFormattedDate()}: */}
                </div>
                <div className="HelloImgBelowText1">
                  <div>
                    {reduceParagraphLength(news?.Description || "", 180)}
                  </div>
                  {youtubeLink ? (
                    <div
                      onClick={() => setopenPop(true)}
                      style={{
                        fontSize: "12px",
                        color: "#F77F00",
                        cursor: "pointer",
                      }}
                    >
                      Click For Details
                    </div>
                  ) : (
                    <div style={{ fontSize: "12px", color: "gray" }}>--</div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="upcomingClasses">
            <div className="upcomingClassHome">Upcoming Classes</div>
            <div className="upComing-lecture-main">
              <div className="homePageClassesContainer">
                {(lectures?.concat(specialLectures) || [])?.length > 0 ? (
                  lectures?.concat(specialLectures)?.map((obj, index) => (
                    <div key={index} className="d-flex gap-2 classDetailHome">
                      <div className="d-flex align-items-center">
                        <img
                          className="upcoming-subImg"
                          src={`${SubjectIcon?.find(
                            (i) => i.subjectName === obj?.subject?.name
                          )?.icon || "/subIcon/ic_png_science.png"
                            }`}
                          alt=""
                        />
                      </div>
                      <UpcomingMainContent
                        obj={obj}
                        handleOpenPopup={handleOpenPopup}
                        reduceParagraphLength={reduceParagraphLength}
                        formatTime={formatTime}
                        formatDateNew={formatDateNew}
                        fromHomePage={'fromHomePage'}
                        events={events}
                      />
                    </div>
                  ))
                ) : (
                  <>
                    <div className="noClass">
                      <div className="d-flex gap-2 justify-content-center flex-column align-items-center">
                        <img
                          src="/HomePageImg/noClass.svg"
                          className=""
                          alt=""
                        ></img>
                        <div className="">
                          <span>No upcoming classes today.</span>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-3 calenderRightSideContainer">
          <div className="calenderHomePage">
            <CalendarComponent style={{ minWidth: "100%" }}></CalendarComponent>
          </div>
          <hr></hr>
          {hasFeature("NB_MGT") && (
            <>
              <div className="noticeBoardTitle mt-2">Notice Board</div>
              {data?.length > 0 ? (
                <div
                  className="noticeMain w-100"
                  style={{ position: "relative" }}
                >
                  {data
                    .slice() // create a shallow copy to avoid mutating original data
                    .sort(
                      (a, b) => new Date(b.created_at) - new Date(a.created_at)
                    ) // sort by date descending
                    .map((item, index) => (
                      <div
                        className="notice_pera d-flex justify-content-between align-items-center w-100"
                        key={index}
                        onClick={() => {
                          setNoticeData(item);
                          setNoticeBoxOpen(true);
                        }}
                        style={{
                          margin: "5px 0px",
                          border: "1px solid rgb(0 0 0 / 8%)",
                          borderRadius: "5px",
                          boxShadow: "4px 13px 11px -16px rgba(0, 0, 0, 0.75)",
                          padding: "10px 20px 10px 10px",
                          overflowWrap: "break-word",
                          backgroundColor: "white",
                        }}
                      >
                        <div className="noticelist d-flex">
                          <FontAwesomeIcon
                            icon={faHandPointRight}
                            className="mr-2"
                            style={{ color: "#F77F00", fontSize: "14px" }}
                          />
                          <div className="w-100">
                            <p
                              style={{
                                marginBottom: "10px",
                                fontSize: "14px",
                                lineHeight: "1.2",
                              }}
                            >
                              {reduceParagraphLength(item?.notice, 80)}
                            </p>

                            {item?.embedded_link ? (
                              <a
                                className="link"
                                href={
                                  item?.embedded_link.includes("http")
                                    ? item.embedded_link
                                    : `https://${item.embedded_link}`
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <p className="notice_Link text-break">
                                  {item?.embedded_link}
                                </p>
                              </a>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              ) : (
                <div className="noClass">
                  <div className="d-flex gap-2 justify-content-center flex-column align-items-center">
                    <img src="/HomePageImg/noClass.svg" alt="" />
                    <div>
                      <span>No notices available.</span>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      {homeScreenWalkThroughPopup && (
        <HomePageTourPopup
          setHomeScreenWalkThroughPopup={setHomeScreenWalkThroughPopup}
          setStepsEnabled={setStepsEnabled}
          Student_Id={Student_Id}
        />
      )}
      {openPop && <HistoryDetaulsPopup setopenPop={setopenPop} news={news} />}
      {popupVisible && (
        <UpcomingLecInsPopup
          handleClosePopup={handleClosePopup}
          popupText={popupText}
          popupTitleText={popupTitleText}
          reduceParagraphLength={reduceParagraphLength}
        />
      )}
      {noticeBoxOpen && (
        <NoticeBoardPopUp
          setNoticeBoxOpen={setNoticeBoxOpen}
          noticeData={noticeData}
        />
      )}
    </div>
  );
}
